import React, { useMemo } from 'react'
import { useResponsive } from './useResponsive'
import { helpers } from '@linqpal/common-frontend'

const { composeResponsiveStyles } = helpers

export function withResponsive (Component) {
  function Responsive ({ style, xs, sm, md, lg, xl, landscape, ...props }) {
    const dimensions = useResponsive()
    const orientedStyles = useMemo(
      () => composeResponsiveStyles(style, { xs, sm, md, lg, xl }, landscape ?? {}, dimensions),
      [dimensions, landscape, lg, md, sm, style, xl, xs],
    )

    return <Component style={orientedStyles} {...props} />
  }

  return Responsive
}
